import { ISkillResource } from "../../skills";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { ISkillBlockList, ISkillBlockResource } from "../types";

export interface ISkillBlockListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt" | "rncpId"> {
    filters?: {
        title?: string;
        rncpId?: string;
        skills?: RelationalFilter<ISkillResource>;
        skillBlock?: RelationalFilter<ISkillBlockResource>;
    };
}

export type ISkillBlockListQueryResult = ISkillBlockList;

const mapFilters = (filters: ISkillBlockListQueryParameters["filters"]) => {
    const { title, rncpId, skills, skillBlock } = filters ?? {};
    return {
        title,
        rncpId,
        uuid: mapRelationalFilter(skillBlock),
        "skills.uuid": mapRelationalFilter(skills),
    };
};

export const skillBlockListQuery: IApiQueryFunction<ISkillBlockListQueryParameters> = ({
    pagination,
    order,
    filters,
}) => {
    return {
        method: "GET",
        url: `/skill_blocks${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useSkillBlockListQuery = createApiQueryHook<ISkillBlockListQueryParameters, ISkillBlockListQueryResult>(
    skillBlockListQuery,
);
